import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdDatePicker from '../../common/elemental/AfitdDatePicker';
// import AfitdTimeSelect from '../../common/elemental/AfitdTimeSelect';
import AfitdTimePicker from '../../common/elemental/AfitdTimePicker';

import cx from 'clsx';
// import _get from 'lodash/get';
import { differenceInMilliseconds, addMilliseconds } from 'date-fns';
// import _set from 'lodash/set';

const styles = theme => ({
    root: {},
    rescheduleMeetingText: {
        marginBottom: '5px',
    },
    dateTimeContainer: {
        width: '360px', // timeSelect 360px / timePicker 420px
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginRight: '24px',
    },
    datePicker: {
        width: '108px',
    },
    startTimePicker: {
        width: '82px',
    },
    endTimePicker: {
        width: '82px',
    },
    closeIconButton: {
        padding: '10px',
    },
    closeIcon: {
        color: 'rgba(17, 30, 20, 0.4)',
        fontSize: '14px',
    },
});

const getDefns = params => {
    const { props, selectedDate, selectedTime, endTime } = params;
    const { setSelectedDate, setSelectedTime } = params;
    const { classes, startDateOnModify, startTimeOnModify, onCancel } = props;
    const { datePicker: datePickerCls, startTimePicker: startTimePickerCls, pickerFilledTextField: pickerFilledTextFieldCls, ...otherClasses } = classes;

    let defns = {
        rescheduleMeetingText: {
            variant: 'body2',
            value: 'Reschedule Meeting',
        },
        startDatePicker: {
            className: cx(datePickerCls),
            value: selectedDate,
            onChange: handleChangeStartDate.bind(null, setSelectedDate, startDateOnModify),
        },
        startTimeSelect: {
            style: { width: '100px' },
            value: selectedTime,
            onModify: handleChangeStartTime.bind(null, setSelectedTime, startTimeOnModify),
        },
        startTimePicker: {
            className: cx(startTimePickerCls),
            minutesStep: 15,
            value: selectedTime,
            onChange: handleChangeStartTime.bind(null, setSelectedTime, startTimeOnModify),
        },
        endTimeSelect: {
            style: { width: '100px' },
            value: endTime,
            isDisabled: true,
        },
        endTimePicker: {
            className: cx(startTimePickerCls),
            minutesStep: 15,
            value: endTime,
            disabled: true,
        },
        closeIconButton: {
            onClick: handleClickCloseIconButton.bind(null, onCancel),
        },
    };

    setClassNameInDefns(defns, otherClasses);

    return defns;
};

const handleChangeStartDate = (setSelectedDate, startDateOnModify, date) => {
    setSelectedDate(date);
    startDateOnModify(date);
};

const handleChangeStartTime = (setSelectedTime, startTimeOnModify, time) => {
    setSelectedTime(time);
    startTimeOnModify(time);
};

const handleClickCloseIconButton = onCancel => {
    if (onCancel) {
        onCancel();
    }
};

const InterviewReschedule = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { isHidden, originalStartDt, originalEndDt } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [selectedDate, setSelectedDate] = useState(originalStartDt);
    const [selectedTime, setSelectedTime] = useState(originalStartDt);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    const durationMs = differenceInMilliseconds(originalEndDt, originalStartDt);
    const endTime = addMilliseconds(selectedTime, durationMs);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({
        props,
        selectedDate,
        selectedTime,
        setSelectedDate,
        setSelectedTime,
        endTime,
    });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    if (isHidden) {
        return null;
    } else {
        return (
            <div {...defns.root}>
                <AfitdTypography {...defns.rescheduleMeetingText} />
                <div {...defns.dateTimeContainer}>
                    <AfitdDatePicker {...defns.startDatePicker} />
                    <AfitdTimePicker {...defns.startTimePicker} />
                    <div>to</div>
                    <AfitdTimePicker {...defns.endTimePicker} />
                    <div {...defns.cancelRescheduleButtonContainer}>
                        <IconButton {...defns.closeIconButton}>
                            <CloseIcon {...defns.closeIcon} />
                        </IconButton>
                    </div>
                </div>
            </div>
        );
    }
    //---------------------------------------------------------------------
};

export default withStyles(styles)(InterviewReschedule);
